import { authedApiFetch } from '../utils/Api';

/**
 * Service for handling 'user' record API calls
 */
const userService = {
	/**
	 * Update user attributes
	 * @param {string} userId - The user ID
	 * @param {object} keyValue - User key value pair, ex: { email_body_sync: true }, { last_login: '2026-09-18T12:00:00.000Z' }
	 * @returns {Promise<Object>} - Updated user data
	 */
	updateUser: async (userId, keyValue) => {
		const response = await authedApiFetch({
			endpoint: `/users/${userId}`,
			method: 'PATCH',
			payload: {
				user: keyValue,
			},
		});
		return response;
	},
};

export default userService;
